import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerPlugin } from "react-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import {
  GalleryAPI,
  GalleryEdit,
  GetQrLink,
} from "../../../redux/requests/gallery";
import { preloaderToggle } from "../../../redux/slices/preloader";
import { navigationStep } from "../../../redux/slices/navigation";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import StepCustomize from "../../../components/stepCustomize";
import { Context } from "../../../components/saveFile/saveFile";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import QrTitleField from "../../../components/input/qrTitleField";
import axios from "axios";
import { getFileFromUrl, isNoEditRoute } from "../../../hooks/helpers";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import { SelectCategory } from "../../../components";
import FileUpload from "../../../components/input/fileUpload";
import { handleFilesUpdate } from "../../../hooks/helpers";
import { setIsStorageModal } from "../../../redux/slices/modals";
import usePremium from "../../../hooks/usePremium";
import useTypeDecription from "../../../hooks/useTypeDecription";
import { useDebouncedCallback } from "use-debounce";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import useUserInfo from "../../../hooks/useUserInfo";

export default function GallerryPage() {
  const { lang, getQrLinkSlice, categoryChange, valueNameQr, toggle } =
    useSelector((state) => ({
      lang: state.changeLang.language.stepTwo.image,
      getQrLinkSlice: state.getQrLinkSlice,
      categoryChange: state.categories.categoryChange,
      valueNameQr: state.saveValue.valueNameQr,
      toggle: state.preloader.toggle,
    }));
  const { id } = useParams();

  const debouncedHandleFilesUpdate = useDebouncedCallback(
    handleFilesUpdate,
    500
  );
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { isPremium } = usePremium();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();

  const { saveGallery, setSaveGallery } = useContext(Context);
  const [qrTitle, setQrTitle] = useState(valueNameQr);
  const [gallery, setGallery] = useState([]);
  const [galleryItem, setGalleryItem] = useState([]);
  const { isAdmin } = useUserInfo();

  const maxFileSize = isAdmin ? null : isPremium ? 99 : 10;

  registerPlugin(
    FilePondPluginFileValidateSize,
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
  );

  useEffect(() => {
    getContent("image");
  }, []);

  const setDefaultImgs = async () => {
    const { data } = await axios.get(
      `/entry/image_pack/${id}/get-images-paths`
    );
    const { data: imagesData } = await axios.get(`/entry/image_pack/get/${id}`);
    setQrTitle(imagesData.qrTitle);
    dispatch(setCategory(imagesData.adsCategories));
    return Promise.all(
      data.map(async (item) => await getFileFromUrl(item, "image"))
    );
  };

  useEffect(() => {
    if (id) {
      setDefaultImgs()
        .then((items) => setGalleryItem(items))
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  function step() {
    if (!!gallery && gallery.length > 0 && getQrLinkSlice.id === null && !id) {
      dispatch(GetQrLink(() => GalleryAPI([gallery, categoryChange, qrTitle])));
    } else if (getQrLinkSlice.id || id) {
      dispatch(
        GetQrLink(() =>
          GalleryEdit([
            getQrLinkSlice.id || id,
            gallery,
            categoryChange,
            qrTitle,
          ])
        )
      );
    }
    dispatch(preloaderToggle(true));
  }

  useEffect(() => {
    setGallery(saveGallery), setGalleryItem(saveGallery);
  }, [saveGallery]);

  useEffect(() => {
    let array = [];
    !!galleryItem &&
      galleryItem?.forEach((item) => {
        array.push(item.file);
      });
    setGallery(array);
  }, [galleryItem]);

  registerPlugin(
    FilePondPluginFileValidateSize,
    FilePondPluginFileValidateType
  );

  useEffect(() => {
    if (
      getQrLinkSlice.status === "success" &&
      !!getQrLinkSlice.link &&
      toggle
    ) {
      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        setSaveGallery(gallery);
        navigate("/qr");
      } else {
        window.location.href = adminEntryLocation;
      }
    } else if (getQrLinkSlice.status === "failed") {
      dispatch(preloaderToggle(false));
    }
  }, [getQrLinkSlice.status]);

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <FileUpload
            files={galleryItem}
            onupdatefiles={(files) =>
              debouncedHandleFilesUpdate(
                files,
                setGalleryItem,
                () => dispatch(setIsStorageModal(true)),
                !isAdmin
              )
            }
            onreorderfiles={(files) =>
              debouncedHandleFilesUpdate(
                files,
                setGalleryItem,
                () => dispatch(setIsStorageModal(true)),
                !isAdmin
              )
            }
            allowFileTypeValidation={true}
            maxFileSize={maxFileSize ? `${maxFileSize}MB` : null}
            allowMultiple={true}
            maxFiles={20}
            name="gallery"
            dataAllowReorder={true}
            allowReorder={true}
            acceptedFileTypes={["image/*"]}
            label={lang[0]}
            popoverText={lang[21]}
          />
          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>
        <SelectCategory />

        <StepCustomize emulate={step} disabled={!gallery.length} />
      </SecondScreen>

      {isNoEditRoute && content}
    </>
  );
}
